import React, { Component } from 'react'
import {connect} from 'react-redux'

import { deleteMembers } from '../../actions/Members'

import Modal from '../Modal'

class DeleteMember extends Component {
  deleteMembers () {
    this.props.deleteMembers({ id: this.props.member.id })
  }
  render () {
    const { ajaxStatus } = this.props.members
    const m = this.props.member
    return (
      <Modal>
        <h3>Eliminare anagrafica</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        {m.name} {m.surname}
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.deleteMembers()}
            >
              elimna
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { deleteMembers })(DeleteMember)



// WEBPACK FOOTER //
// ./src/components/Members/DeleteMember.js